/**
 * Created by Omar Alejandro Leonor Avalos on 2017-06-05.
 * Actions for the container.
 */
import { NOTIFY } from './types';

export const notify = (payload) => {
    return {
        type: NOTIFY,
        payload
    };
};



// WEBPACK FOOTER //
// ./containers/playground/actions.js